// src/components/Checkout/DeliveryAddressForm.jsx
import React from "react";

export default function DeliveryAddressForm({
  deliveryAddress,
  setDeliveryAddress,
  deliveryQuote,
  updateDeliveryField,
}) {
  const Required = () => <span className="text-red-500 ml-1">*</span>;

  const setField = (field, value) => {
    if (typeof updateDeliveryField === "function") {
      updateDeliveryField(field, value);
      return;
    }
    // fallback (shouldn’t happen)
    setDeliveryAddress((p) => ({ ...p, [field]: value }));
  };

  return (
    <div className="space-y-4 lg:col-span-2">
      <h3 className="text-lg font-bold text-slate-900 dark:text-white">
        Delivery Address
      </h3>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Line 1 */}
        <div className="space-y-2 lg:col-span-2">
          <label className="text-sm font-semibold text-slate-700 dark:text-slate-300">
            Address Line 1 (house number + street)
            <Required />
          </label>
          <input
            required
            value={deliveryAddress.line1}
            onChange={(e) => setField("line1", e.target.value)}
            className="w-full px-4 py-3 rounded-lg border border-slate-200 dark:border-slate-700 dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-primary focus:border-primary transition-colors outline-none"
            type="text"
          />
        </div>

        {/* Line 2 */}
        <div className="space-y-2 lg:col-span-2">
          <label className="text-sm font-semibold text-slate-700 dark:text-slate-300">
            Address Line 2 (optional)
          </label>
          <input
            value={deliveryAddress.line2}
            onChange={(e) => setField("line2", e.target.value)}
            className="w-full px-4 py-3 rounded-lg border border-slate-200 dark:border-slate-700 dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-primary focus:border-primary transition-colors outline-none"
            type="text"
          />
        </div>

        {/* City */}
        <div className="space-y-2">
          <label className="text-sm font-semibold text-slate-700 dark:text-slate-300">
            Town/City
            <Required />
          </label>
          <input
            required
            value={deliveryAddress.city}
            onChange={(e) => setField("city", e.target.value)}
            className="w-full px-4 py-3 rounded-lg border border-slate-200 dark:border-slate-700 dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-primary focus:border-primary transition-colors outline-none"
            type="text"
          />
        </div>

        {/* Postcode (NOT persisted) */}
        <div className="space-y-2">
          <label className="text-sm font-semibold text-slate-700 dark:text-slate-300">
            Postcode
            <Required />
          </label>
          <input
            required
            value={deliveryAddress.postcode}
            onChange={(e) => {
              // ✅ postcode updates state only (never saved)
              setDeliveryAddress((p) => ({ ...p, postcode: e.target.value }));
            }}
            className="w-full px-4 py-3 rounded-lg border border-slate-200 dark:border-slate-700 dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-primary focus:border-primary transition-colors outline-none"
            type="text"
          />

          {deliveryQuote?.status === "loading" && (
            <p className="mt-2 text-xs text-slate-500">Checking delivery…</p>
          )}
          {deliveryQuote?.status === "ok" && (
            <p className="mt-2 text-xs text-green-600">Delivery available ✅</p>
          )}
        </div>
      </div>
    </div>
  );
}
